import { formatMoney, isPublisher } from '~/helpers'
import i18n from '~/i18n'
import { primary as theme } from '~/styles/themes'

import {
  abbreviateCurrency,
  formatCompareMetricLabel,
  formatStylesChart,
  maxValue
} from '../../helpers'
import { CreateDataset } from '../types'
import { OptionsScale } from './types'

const axisID = 'y-totalSpent'

const settings = {
  get label() {
    return isPublisher()
      ? i18n.t('rm:metrics.adsRevenue')
      : i18n.t('rm:metrics.investment')
  },
  formatData: (value: number) => abbreviateCurrency(value),
  formatAdditionalData: (value: number) => formatMoney(value),
  color: theme.colors.danger,
  dataKey: 'totalSpentNumber' as keyof ReportHistoryCampaigns,
  order: 20
}

const dataset: CreateDataset = ({ data, isCompare = false }) => ({
  yAxisID: isCompare ? `${axisID}-compare` : axisID,
  type: 'line',
  label: formatCompareMetricLabel({ label: settings.label, isCompare }),
  data: data?.[settings.dataKey] || null,
  order: isCompare ? settings.order - 1 : settings.order,

  ...formatStylesChart({ color: settings.color, isCompare })
})

const optionsScale: OptionsScale = ({
  selectedMetrics,
  showScaleRuler = true,
  drawOnChartArea = true,
  position = 'left',
  data,
  isCompare = false
}) => {
  const shouldApplyMax = selectedMetrics?.includes('income')

  return {
    [isCompare ? `${axisID}-compare` : axisID]: {
      display: showScaleRuler,
      grid: {
        // If true, draw lines on the chart area inside the axis lines. This is useful
        // when there are multiple axes and you need to control which grid lines are drawn.
        drawOnChartArea
      },
      position,
      suggestedMin: 0,
      suggestedMax: shouldApplyMax ? maxValue({ data })?.money : null,
      beginAtZero: true,
      ticks: {
        z: -1,
        color: settings.color,
        callback: settings.formatData
      }
    }
  }
}

const totalSpentPreset = { axisID, dataset, optionsScale, settings }

export default totalSpentPreset
